import { render, staticRenderFns } from "./BaseHeaderCategory.vue?vue&type=template&id=5ed49a0c&"
import script from "./BaseHeaderCategory.vue?vue&type=script&lang=js&"
export * from "./BaseHeaderCategory.vue?vue&type=script&lang=js&"
import style0 from "./BaseHeaderCategory.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports